import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  collection,
  collectionSnapshots,
  doc,
  docSnapshots,
  Firestore,
  setDoc,
} from '@angular/fire/firestore';
import { ReviewerInteraction } from '@sleipai/sleip-models';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable()
export class ReviewerInteractionsService {
  constructor() {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  getReviewerInteractionsById(id: string) {
    return docSnapshots(doc(this.firestore, `reviewerInteraction/${id}`)).pipe(
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef),
      map((snap) => {
        return {
          id: snap.id,
          ...snap.data(),
        } as ReviewerInteraction;
      })
    );
  }

  updateReviewerActionById(update: any) {
    const reviewReference = doc(
      this.firestore,
      `reviewerInteraction/${update.recordingId}`
    );
    return setDoc(reviewReference, update, { merge: true });
  }

  getCompletedReviewerInteractions() {
    const reviewerInteractionRef = collection(
      this.firestore,
      'reviewerInteraction'
    );
    return collectionSnapshots(reviewerInteractionRef).pipe(
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef),
      map((snap) => {
        return snap.map((interaction) => {
          const data = interaction.data();
          const id = interaction.id;
          return { id, ...data };
        });
      })
    );
  }

  createStats(leaderboard: any) {
    const reference = doc(this.firestore, `funStats/reviewLeaderBoard`);
    setDoc(reference, leaderboard);
  }

  fetchReviewerLeaderBoard() {
    const reference = doc(this.firestore, `funStats/reviewLeaderBoard`);
    return docSnapshots(reference).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((reviewLeaderBoardSnap) => {
        const reviewLeaderBoardData = reviewLeaderBoardSnap.data() as any;
        return Object.keys(reviewLeaderBoardData).map(
          (key) => ({
            id: key,
            ...reviewLeaderBoardData[key],
          })
        );
      })
    );
  }
}
